import React, { useState, useEffect } from 'react'
import AccountPaper from '@/components/Account/AccountPaper'
import { Typography } from '@evocolabs/orkaui'
import AccountAudiogram from '@/components/Account/ServiceCenter/UploadAudiogram/AccountAudiogram'
import {
  PrefittingEntrance,
  PrefittingEntranceMobile
} from '@/components/Account/ServiceCenter/PrefittingEntrance'
import HearingTestEntrance from '@/components/Account/ServiceCenter/HearingTestEntrance'

import { Box } from '@mui/material'

const ServiceCenter = ({ prefittingStat, isKYCSubmitDone }) => {
  return (
    <div style={{ width: '100%' }}>
      <AccountPaper style={{ backgroundColor: 'unset' }}>
        <div
          style={{
            marginBottom: '16px',
            backgroundColor: '#ffffff',
            borderRadius: '12px',
            padding: '16px 40px'
          }}
        >
          <Typography variant="T1">Service Center</Typography>
        </div>
        <AccountAudiogram />
        {!isKYCSubmitDone ? (
          <PrefittingEntrance prefittingStat={prefittingStat} />
        ) : (
          <Box m="16px 0" />
        )}
        <HearingTestEntrance />
      </AccountPaper>
    </div>
  )
}

const ServiceCenterMobile = ({ prefittingStat, isKYCSubmitDone }) => {
  return (
    <div style={{ width: '100%', flexDirection: 'column' }}>
      <AccountAudiogram />
      {!isKYCSubmitDone ? (
        <PrefittingEntrance prefittingStat={prefittingStat} />
      ) : (
        <Box m="16px 0" />
      )}
      <HearingTestEntrance />
    </div>
  )
}

export { ServiceCenter, ServiceCenterMobile }
